import { Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

import { isTestMode } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"
import scrollToElement from "helpers/scroll-to-element"

import Ratings from "../ratings"

import Affirm from "./affirm"
import Klarna from "./klarna"

const InternalRatingsFinancing = ({
  hideMiniview,
  title,
  isMiniview,
  pricing,
  cartSummary,
  wizardLoading,
}) => {
  const [priceToDisplay, setPriceToDisplay] = useState(
    pricing.price_to_display || 0
  )

  useEffect(() => {
    let calculatedPrice = pricing.price_to_display || 0

    if (cartSummary) {
      calculatedPrice += cartSummary.cart_total
    }

    setPriceToDisplay(calculatedPrice)
  }, [cartSummary, pricing.price_to_display])

  if (priceToDisplay <= 0 || wizardLoading) {
    return ""
  }
  const handleRatingsClick = () => {
    scrollToElement("#product-reviews", hideMiniview ? 90 : 350)
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-reviews-count-pdp",
      })
    }
  }

  return (
    <Flex
      alignItems={sl.config.klarna_osm_pdp ? "center" : "end"}
      gap={1}
      justifyContent="space-between"
      mb="12px"
    >
      {title && sl.config.use_yotpo && (
        <Ratings handleClick={handleRatingsClick} />
      )}

      {sl.config.enable_affirm && !isMiniview && <Affirm />}
      {sl.config.klarna_osm_pdp &&
        enableKlarnaCheckout() &&
        priceToDisplay <= sl.config.klarna_max &&
        !isMiniview && <Klarna />}
    </Flex>
  )
}

const mapStateToProps = (state, ownProps) => {
  let title = state.wizard.title
  if (state.wizard.loading) {
    if (ownProps.data.wizard_header) {
      title = ownProps.data.wizard_header.title
    } else {
      title = ""
    }
  }
  return {
    cartSummary: state.cart.summary,
    hideMiniview: state.previewImageUI.miniview.scrollHide,
    openedDescriptionPanels: state.panel.openedInfoPanelIndexes,
    pricing: state.wizardUI.currentPricing,
    title,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalRatingsFinancing.propTypes = {
  cartSummary: PropTypes.object,
  hideMiniview: PropTypes.bool,
  isMiniview: PropTypes.bool,
  pricing: PropTypes.object,
  title: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const RatingsFinancing = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalRatingsFinancing)

export default RatingsFinancing
